import { genderConstants, participantConstants } from 'tods-competition-factory';
import { preferencesConfig } from 'config/preferencesConfig';
import { renderParticipant } from 'courthive-components';
import { isFunction, isObject } from 'functions/typeOf';
import { scalesMap } from 'config/scalesConfig';

const { MALE, FEMALE } = genderConstants;
const { PAIR } = participantConstants;

export const formatParticipant =
  (onClick, config?: { participantDetail?: string; useParticipantName?: boolean }) => (cell, placeholder, layout) => {
    const def = cell.getColumn().getDefinition();
    const sideNumber = (def.field === 'side1' && 1) || (def.field === 'side2' && 2);
    const elem = document.createElement('div');
    const data = cell.getRow().getData();
    const hasWinner = data.winningSide;
    const value = cell.getValue();
    const participant = data.participant || value?.participant || (data.person && data);
    if (participant) {
      const scaleAttributes = scalesMap[preferencesConfig.get().activeScale];

      const rendered = (participant) => {
        return renderParticipant({
          eventHandlers: {
            participantClick: (params) => {
              return isFunction(onClick) && onClick({ ...params, event: params.pointerEvent, cell });
            },
          },
          composition: {
            theme: 'default',
            configuration: {
              participantDetail: config?.participantDetail || 'TEAM',
              useParticipantName: config?.useParticipantName,
              genderColor: true,
              winnerColor: !!sideNumber,
              scaleAttributes,
              flag: false,
            },
          },
          sideContainer: elem ? true : undefined,
          matchUp: sideNumber ? data.matchUp : undefined,
          participant,
          placeholder,
          sideNumber: sideNumber || undefined,
        });
      };

      const renderPairParticipant = (participant) => {
        const div = document.createElement('div');
        div.className = 'flexrow flexjustifystart';
        participant.individualParticipants?.forEach((individual, i) => {
          const individualEl = rendered(individual);
          // Cap each individual to half the cell so long doubles names don't wrap
          // or balloon the column (which made it look jagged). Mirrors the fixed
          // name width used in the participants table.
          individualEl.style.maxWidth = 'calc(50% - 0.5em)';
          individualEl.style.overflow = 'hidden';
          individualEl.style.whiteSpace = 'nowrap';
          individualEl.style.textOverflow = 'ellipsis';
          div.appendChild(individualEl);
          if (!i) {
            const spacer = document.createElement('span');
            spacer.style.width = '1em';
            spacer.innerHTML = '&nbsp;';
            div.appendChild(spacer);
          }
        });

        return div;
      };
      return layout === 'sideBySide' && participant.participantType === PAIR
        ? renderPairParticipant(participant)
        : rendered(participant);
    }
    if (hasWinner) {
      const winningSide = def.field === data.winningSide;
      elem.style.color = winningSide ? 'var(--tmx-accent-green)' : 'var(--tmx-accent-red)';
    } else {
      const sex = value?.sex || data?.person?.sex;
      const color = (sex === MALE && 'var(--tmx-accent-blue)') || (sex === FEMALE && 'var(--tmx-accent-pink)') || '';
      elem.style.color = color;
    }

    elem.innerHTML = (isObject(value) ? (value as any).participantName : value) || '';

    return elem;
  };
